import { useState } from "react";
import { Link } from "react-router-dom";
import content from "../../data/content";
import SectionDivider from "../../components/SectionDivider";
import CtaBanner from "../../components/CtaBanner";
import "./Courses.css";

const { courses } = content;

function TextWithBreaks({ text }) {
  return text.split("\n").map((line, i, arr) => (
    <span key={i}>
      {line}
      {i < arr.length - 1 && <br />}
    </span>
  ));
}

// Category mapping for each course slug
const slugToCategory = {
  "wild-brow": "眉部課程",
  "snow-mist-brow": "眉部課程",
  "misty-eye-course": "眼部課程",
  "petal-lip-course": "唇部課程",
  "full-program": "全科班",
};

// Build ordered category list (preserving content order for representative images)
const categoryOrder = [];
const categoryCoverMap = {};
courses.courseList.items.forEach((c) => {
  const cat = slugToCategory[c.slug] || "其他";
  if (!categoryOrder.includes(cat)) {
    categoryOrder.push(cat);
    categoryCoverMap[cat] = c.images[0];
  }
});
categoryCoverMap["全部"] = courses.courseList.items[0].images[0];
const allCategories = ["全部", ...categoryOrder];

export default function Courses() {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const filtered =
    selectedCategory === "全部"
      ? courses.courseList.items
      : courses.courseList.items.filter(
          (c) => (slugToCategory[c.slug] || "其他") === selectedCategory
        );

  return (
    <div className="courses-page">
      <section className="courses-header">
        <p className="page-label">Courses</p>
        <h1 className="page-heading">課程介紹</h1>
      </section>

      {/* ---- Teaching Philosophy ---- */}
      <section className="courses-section">
        <div className="courses-section__inner">
          <p className="section-label">{courses.teaching.sectionLabel}</p>
          <h2 className="courses-teaching__heading">
            {courses.teaching.heading}
          </h2>
          <p className="courses-teaching__sub">{courses.teaching.subheading}</p>

          <div className="courses-teaching__blocks">
            {courses.teaching.blocks.map((block, i) => (
              <div key={i} className="courses-teaching__block">
                <h3 className="courses-teaching__block-heading">
                  {block.heading}
                </h3>
                <p className="courses-teaching__block-body">
                  <TextWithBreaks text={block.body} />
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SectionDivider />

      {/* ---- Course List ---- */}
      <section className="courses-section">
        <div className="courses-section__inner">
          <h2 className="courses-list__heading">
            {courses.courseList.sectionLabel}
          </h2>

          {selectedCategory === null ? (
            /* ---- Category Picker ---- */
            <div className="courses-picker__grid">
              {allCategories.map((cat) => (
                <button
                  key={cat}
                  className="courses-picker__card"
                  onClick={() => setSelectedCategory(cat)}
                >
                  <img
                    className="courses-picker__img"
                    src={categoryCoverMap[cat]}
                    alt={cat}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                  <div className="courses-picker__overlay" />
                  <span className="courses-picker__label">{cat}</span>
                </button>
              ))}
            </div>
          ) : (
            <>
              {/* ---- Back + Filter Tabs ---- */}
              <div className="courses-filter">
                <button
                  className="courses-filter__back"
                  onClick={() => setSelectedCategory(null)}
                >
                  ← 返回分類
                </button>
                <div className="courses-filter__tabs">
                  {allCategories.map((cat) => (
                    <button
                      key={cat}
                      className={`courses-filter__btn ${
                        selectedCategory === cat
                          ? "courses-filter__btn--active"
                          : ""
                      }`}
                      onClick={() => setSelectedCategory(cat)}
                    >
                      {cat}
                    </button>
                  ))}
                </div>
              </div>

              {/* ---- Course Cards ---- */}
              <div className="courses-list">
                {filtered.map((course) => (
                  <Link
                    key={course.slug}
                    to={`/courses/${course.slug}`}
                    className="course-card course-card--link"
                  >
                    <h3 className="course-card__name">{course.name}</h3>
                    {course.description && (
                      <p className="course-card__desc">{course.description}</p>
                    )}
                    {course.includes && (
                      <p className="course-card__desc">
                        包含：{course.includes.map((i) => i.name).join("、")}
                      </p>
                    )}
                    <span className="course-card__arrow">查看詳情 →</span>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      <CtaBanner />
    </div>
  );
}
